<div *ngIf="error" class="alert alert-danger alert-dismissible fade show" role="alert">
  {{ error }}
  <button type="button" class="btn-close btn-sm outline-none" data-bs-dismiss="alert" aria-label="Close">
  </button>
</div>

<div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">

  <ng-container i18n="@@escalationTicket.success">Your escalation ticket has been sent successfully</ng-container>
  <button type="button" class="btn-close btn-sm outline-none" data-bs-dismiss="alert" aria-label="Close">
  </button>
</div>

<form class="form" class="white" [formGroup]="form" (ngSubmit)="onSubmit()">
  <form-field class="front mb-0" label="Your Email *" i18n-label="@@escalationTicket.email.label">
    <input [disabled]="!isLoggedIn()" type="email" required formControlName="email"
      placeholder="Enter Your Email Address" i18n-placeholder="@@escalationTicket.email.placeholder" />
  </form-field>
  <small i18n="@@support.required" class="text-danger" *ngIf="email?.errors?.required && email?.touched">* This field is
    required.</small>
  <small i18n="@@support.validEmailError" class="text-danger" *ngIf="email?.value && email?.errors?.email ">
    Please enter a valid email address.
  </small>

  <form-field class="front mb-0 mt-3" label="Ticket ID *" i18n-label="@@escalationTicket.ticketId.label">
    <input required type="text" inputmode="numeric" formControlName="ticketId" placeholder="Ticket ID (numbers only)"
      i18n-placeholder="@@escalationTicket.ticketId.placeholder" />
  </form-field>
  <small i18n="@@support.required" class="text-danger" *ngIf="ticketId?.errors?.required && ticketId?.touched">* This
    field is required.</small>

  <small i18n="@@escalationTicket.ticketId.invalidError" class="text-danger" *ngIf="
      (ticketId?.errors?.min || ticketId?.errors?.pattern) && ticketId?.dirty
    ">
    Please enter a valid Ticket ID (numbers only).
  </small>
  <div class="mt-3">
    <form-field class="front mb-0 pb-0" label="Escalation Category *"
      i18n-label="@@escalationTicket.escalationCategory.label">
      <ng-select [clearable]="false" formControlName="escalationType" placeholder="Select your escalation category"
        i18n-placeholder="@@escalationTicket.escalationCategory.placeholder">
        <ng-option [value]="EscalationType.COMPLIANCE_AND_VERIFICATION_CONCERNS"
          i18n="@@escalationTicket.escalationType.compliance">Compliance & Verification Concerns</ng-option>
        <ng-option [value]="EscalationType.SECURITY_AND_UNAUTHORIZED_ACCESS"
          i18n="@@escalationTicket.escalationType.security">Security & Unauthorized Access</ng-option>
        <ng-option [value]="EscalationType.FIAT_DEPOSIT_AND_WITHDRAWAL_PROBLEMS"
          i18n="@@escalationTicket.escalationType.fiatDepositAndWithdrawal">Fiat Deposit & Withdrawal
          Problems</ng-option>
        <ng-option [value]="EscalationType.TRADING_AND_TRANSACTION_ISSUES"
          i18n="@@escalationTicket.escalationType.trading">Trading & Transaction Issues</ng-option>
        <ng-option [value]="EscalationType.CRYPTO_DEPOSITS_AND_WITHDRAWALS_PROBLEMS"
          i18n="@@escalationTicket.escalationType.cryptoDepositsAndWithdrawalsProblems">Crypto Deposits & Withdrawals
          Problems</ng-option>
        <ng-option [value]="EscalationType.THIRD_PARTY_AND_PARTNER_SERVICE_ISSUES"
          i18n="@@escalationTicket.escalationType.thirdParty">Third-Party & Partner Service Issues</ng-option>


        <ng-option [value]="EscalationType.PLATFORM_AND_SERVICE_DOWNTIME"
          i18n="@@escalationTicket.escalationType.platformAndServiceDowntime">Platform & Service Downtime</ng-option>
        <ng-option [value]="EscalationType.CUSTOMER_EXPERIENCE_AND_SUPPORT_QUALITY"
          i18n="@@escalationTicket.escalationType.customerExperienceAndSupportQuality">Customer Experience & Support
          Quality</ng-option>
        <ng-option [value]="EscalationType.WALLET_AND_ACCOUNT_DISCREPANCIES"
          i18n="@@escalationTicket.escalationType.walletAndAccountDiscrepancies">Wallet & Account
          Discrepancies</ng-option>
      </ng-select>
    </form-field>
    <small i18n="@@support.required" class="text-danger"
      *ngIf="escalationType?.errors?.required && escalationType?.touched">* This field is required.</small>

    <form-field class="front textarea mb-0 mt-3" label="Description *"
      i18n-label="@@escalationTicket.description.label">
      <textarea formControlName="description" placeholder="Enter your escalation" rows="5" required
        i18n-placeholder="@@escalationTicket.description.placeholder"></textarea>
    </form-field>
    <small i18n="@@support.required" class="text-danger" *ngIf="description?.errors?.required && description?.touched">*
      This field is required.</small>
  </div>

  <div class="submit mb-4 pt-4">
    <button class="btn btn-primary btn-block" [disabled]="loading || (!form.valid && form.touched) || loadingCaptcha">
      <ng-container *ngIf="loading || loadingCaptcha; else notLoading" i18n="@@support.submitLoading">
        Loading...
      </ng-container>

      <ng-template #notLoading>
        <ng-container i18n="@@escalationTicket.submitButton">
          Send Escalation Ticket
        </ng-container>
      </ng-template>
    </button>
  </div>
</form>